import { divIcon, type DivIcon } from 'leaflet';
import type { NoddiIconName } from 'noddi-ui-common';
import { MARKER_BLUE, MARKER_RED } from './constants';
import { circularBadgeMarkerHtml } from './mapBadgeMarker';

/** Lucide `Building2` — use for garages / stations / workshops. */
export const GARAGE_ICON_NAME = 'Building2' satisfies NoddiIconName;

/** Lucide `Warehouse` — use for storage facilities / tire hotels. */
export const STORAGE_FACILITY_ICON_NAME = 'Warehouse' satisfies NoddiIconName;

export const GARAGE_MARKER_COLOR = MARKER_RED;
export const SITE_PORT_MARKER_COLOR = MARKER_BLUE;
export const STORAGE_FACILITY_MARKER_COLOR = MARKER_BLUE;

// Paths from lucide-react-native v0.542 (Building2 / DoorOpen / Warehouse). Keep in sync when upgrading lucide.
const BUILDING_2_PATHS = [
  'M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z',
  'M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2',
  'M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2',
  'M10 6h4',
  'M10 10h4',
  'M10 14h4',
  'M10 18h4'
] as const;

const DOOR_OPEN_PATHS = [
  'M11 20H2',
  'M11 4.562v16.157a1 1 0 0 0 1.242.97L19 20V5.562a2 2 0 0 0-1.515-1.94l-4-1A2 2 0 0 0 11 4.561z',
  'M11 4H8a2 2 0 0 0-2 2v14',
  'M14 12h.01',
  'M22 20h-3'
] as const;

const WAREHOUSE_PATHS = [
  'M18 21V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11',
  'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 1.132-1.803l7.95-3.974a2 2 0 0 1 1.837 0l7.948 3.974A2 2 0 0 1 22 8z',
  'M6 13h12',
  'M6 17h12'
] as const;

const garageLeafletIcon = divIcon({
  className: '',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
  popupAnchor: [0, -18],
  html: circularBadgeMarkerHtml(BUILDING_2_PATHS, GARAGE_MARKER_COLOR)
});

const sitePortLeafletIcon = divIcon({
  className: '',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
  popupAnchor: [0, -18],
  html: circularBadgeMarkerHtml(DOOR_OPEN_PATHS, SITE_PORT_MARKER_COLOR)
});

const storageFacilityLeafletIcon = divIcon({
  className: '',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
  popupAnchor: [0, -18],
  html: circularBadgeMarkerHtml(WAREHOUSE_PATHS, STORAGE_FACILITY_MARKER_COLOR)
});

export const getGarageLeafletIcon = (): DivIcon => garageLeafletIcon;

export const getSitePortLeafletIcon = (): DivIcon => sitePortLeafletIcon;

export const getStorageFacilityLeafletIcon = (): DivIcon => storageFacilityLeafletIcon;

/** SVG path list for React legend icons that must match the leaflet marker glyphs. */
export const GARAGE_ICON_PATHS = BUILDING_2_PATHS;
export const SITE_PORT_ICON_PATHS = DOOR_OPEN_PATHS;
export const STORAGE_FACILITY_ICON_PATHS = WAREHOUSE_PATHS;
